// Formatting helpers for YUMAERA TRADEPLAN

export const PLAN_STATE = {
  ACTIVE: { label: "ACTIVE", color: "#22c55e" },
  MISSED_ENTRY: { label: "MISSED ENTRY", color: "#f59e0b" },
  INVALIDATED: { label: "INVALIDATED", color: "#ef4444" },
  EXPIRED: { label: "EXPIRED", color: "#ef4444" },
  STALE: { label: "STALE DATA", color: "#f59e0b" },
  SUSPENDED: { label: "SUSPENDED", color: "#22d3ee" },
  STANDBY: { label: "STANDBY", color: "#8a8a95" },
  MONITOR: { label: "MONITOR", color: "#a78bfa" },
};
export const planState = (s) => PLAN_STATE[s] || { label: s || "—", color: "#8a8a95" };


export const fmtPrice = (v) => {
  if (v == null || isNaN(v)) return "--";
  const n = Number(v);
  if (n >= 1000) return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (n >= 1) return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  return n.toLocaleString("en-US", { minimumFractionDigits: 4, maximumFractionDigits: 6 });
};

export const fmtPct = (v) => {
  if (v == null || isNaN(v)) return "--";
  const n = Number(v);
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
};

export const fmtCompact = (v) => {
  if (v == null || isNaN(v)) return "--";
  const n = Number(v);
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(2)}K`;
  return `$${n.toFixed(0)}`;
};

export const PAIR_COLORS = {
  BTC: "#f7931a",
  HYPE: "#a78bfa",
  ZEC: "#22d3ee",
  ETH: "#627eea",
  SOL: "#14f195",
};

export const colorForBase = (base) => PAIR_COLORS[base] || "#8b5cf6";

// countdown formatter from unix seconds
export const fmtCountdown = (targetTs) => {
  if (!targetTs) return "--:--:--";
  const diff = targetTs - Math.floor(Date.now() / 1000);
  if (diff <= 0) return "EXPIRED";
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const witaClock = () => {
  const now = new Date();
  // WITA = UTC+8
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const wita = new Date(utc + 8 * 3600000);
  return {
    time: wita.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" }),
    date: wita.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }),
  };
};
